import { IHotelList } from "@/feature/hotel/search/types/hotel-search-page-type";

export type HotelRoutePreview = {
  address: string;
  latitude: number | null;
  longitude: number | null;
  name: string;
};

const HOTEL_PREVIEW_QUERY_KEYS = {
  address: "hotel_address",
  latitude: "hotel_lat",
  longitude: "hotel_lng",
  name: "hotel_name",
} as const;

function toFiniteCoordinate(value: unknown) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function normalizeSearchParam(value: string | string[] | undefined) {
  if (typeof value === "string") {
    return value;
  }

  if (Array.isArray(value)) {
    return value[0];
  }

  return undefined;
}

function toFiniteNumber(value: string | undefined) {
  return toFiniteCoordinate(value);
}

export function buildHotelRoutePreview(hotel: IHotelList): HotelRoutePreview {
  return {
    address: `${hotel.contact_details.address} - ${hotel.contact_details.country}`,
    latitude: toFiniteCoordinate(hotel.geolocation?.latitude),
    longitude: toFiniteCoordinate(hotel.geolocation?.longitude),
    name: hotel.name,
  };
}

export function buildHotelRoutePreviewParams(hotel: IHotelList) {
  const preview = buildHotelRoutePreview(hotel);
  const params = new URLSearchParams();

  params.set(HOTEL_PREVIEW_QUERY_KEYS.name, preview.name);
  params.set(HOTEL_PREVIEW_QUERY_KEYS.address, preview.address);

  return params;
}

export function parseHotelRoutePreview(
  searchParams: Record<string, string | string[] | undefined>,
): HotelRoutePreview | null {
  const name = normalizeSearchParam(searchParams[HOTEL_PREVIEW_QUERY_KEYS.name]);
  const address = normalizeSearchParam(
    searchParams[HOTEL_PREVIEW_QUERY_KEYS.address],
  );

  if (!name || !address) {
    return null;
  }

  return {
    address,
    latitude: toFiniteNumber(
      normalizeSearchParam(searchParams[HOTEL_PREVIEW_QUERY_KEYS.latitude]),
    ),
    longitude: toFiniteNumber(
      normalizeSearchParam(searchParams[HOTEL_PREVIEW_QUERY_KEYS.longitude]),
    ),
    name,
  };
}
